import { useEffect, useState } from 'react';
import { useStoreState } from 'state';

const useRiskRating = (cashflowAtRisk?: number) => {
  const { userEntity } = useStoreState(({ UserState }) => UserState);
  const [riskRating, setRiskRating] = useState<number>();

  useEffect(() => {
    if (cashflowAtRisk !== undefined) {
      const riskToleranceDivider = (userEntity?.riskTolerance || 10000) / 5;
      const ratingLevel =
        Math.floor(Math.abs(cashflowAtRisk) / riskToleranceDivider) + 1;

      setRiskRating(Math.min(5, ratingLevel));
    }
  }, [cashflowAtRisk, userEntity?.riskTolerance]);

  return { riskRating };
};

export default useRiskRating;
